const EventStatus = {
  Finished: 'FINISHED',
  InProgress: 'IN_PROGRESS',
  Created: 'CREATED',
  Cancelled: 'CANCELLED',
};

export default EventStatus;
